import apiService from "./apiServices";

export const saveCSVFile = async(formData, token) => {
    try {
        const response = await apiService('/leadsUpload/import', 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving customer task is failed. Please try again.');
        }
  }

export const getAllCSVFiles = async  (token) => {
  try {
    const response = await apiService('/leadsUpload/all', 'GET', null, null, token);
    return response;
  } catch (error) {
    throw (error?.message || 'Get All Csv Files service failed. Please try again.');
  }
};